<template>
  <v-container class="white">
    <v-row v-if="advertiser">
      <v-col cols="12">
        <v-container>
          <v-row no-gutters>
            <v-col cols="auto">
              <h2 class="headline mb-3">
                {{ advertiser.name }}
                <small class="caption">
                  ID: {{ advertiser.panelId || "N/A" }} -
                  <span
                    :class="[
                      advertiser.panelStatus
                        ? 'success--text'
                        : 'primary--text',
                    ]"
                    >{{ advertiser.panelStatusText || "N/A" }}</span
                  >
                </small>
              </h2>
              <p class="subtitle-1">{{ advertiser.description }}</p>
            </v-col>
            <v-spacer />
            <CompanyCreate :company="advertiser" />
          </v-row>
          <v-divider />
        </v-container>
        <v-row>
          <v-col
            cols="12"
            v-if="getBannersByCompany(advertiser._id).length == 0"
          >
            <h5 class="text-center">No banners for this advertiser</h5>
          </v-col>
          <v-col
            v-for="(banner, index) in getBannersByCompany(advertiser._id)"
            :key="banner._id"
            cols="12"
            :sm="6"
            :lg="3"
            :xl="3"
          >
            <v-card flat outlined :loading="loadingID == banner._id">
              <v-container class="py-0">
                <v-row justify="space-between">
                  <v-col cols="6">
                    <Banner
                      visibility
                      :banner="banner"
                      :key="banner._id"
                      :counter="index"
                      transition="scale-transition"
                    ></Banner>
                  </v-col>
                  <v-col cols="6" class="text-center pl-0">
                    <!-- <v-chip :class="banner.panelStatus ? 'success' : 'primary'" dark label small>
        <v-icon left small v-if="banner.panelStatus"> mdi-check </v-icon>
        <v-icon left small v-else> mdi-pause </v-icon>
        {{ banner.panelStatusText || "Banner status N/A" }}
      </v-chip> -->
                    <v-col
                      :class="[
                        banner.panelStatus ? 'success' : 'primary',
                        'white--text',
                      ]"
                    >
                      <span>
                        {{ banner.panelStatusText || "Banner status N/A" }}
                      </span>
                    </v-col>
                    <v-divider />

                    <v-checkbox
                      dense
                      :disabled="!(role == 'ADMIN')"
                      hide-details="true"
                      color="primary"
                      v-model="banner.promote"
                      label="Show at the top"
                      @change="statusChange(banner)"
                    ></v-checkbox>
                    <v-checkbox
                      dense
                      :disabled="!(role == 'ADMIN')"
                      hide-details="true"
                      color="primary"
                      v-model="banner.permission"
                      label="Permision"
                      @change="statusChange(banner)"
                    ></v-checkbox>
                    <v-checkbox
                      dense
                      :disabled="!(role == 'ADMIN')"
                      hide-details="true"
                      color="primary"
                      v-model="banner.forceShow"
                      label="Force show"
                      @change="statusChange(banner)"
                    ></v-checkbox>

                    <!-- <v-checkbox
                      dense
                      :disabled="!(role == 'ADMIN')"
                      hide-details="true"
                      color="primary"
                      v-model="banner.isActive"
                      label="Is Active"
                      @change="statusChange(banner)"
                    ></v-checkbox> -->
                    <div align="start" class="caption">
                      {{ banner.description | lengthFilter(225) }}
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    Banner: () => import("@/components/Dashboard/BannerThumb"),
    CompanyCreate: () => import("@/components/Dashboard/AdvertisersCreate"),
  },
  data() {
    return {
      loading: true,
      loadingID: "",
      companyForm: false,
    };
  },
  props: {
    advertiserID: {
      type: String,
    },
  },
  computed: {
    ...mapGetters(["getBannersByCompany", "role"]),
    advertiser() {
      return this.$store.getters.getAdvertiserById(this.advertiserID);
    },
  },
  methods: {
    ...mapActions([
      "fetchAdvertisers",
      "fetchBanners",
      "updateBanner",
      "setSnackbar",
    ]),
    async statusChange(banner) {
      this.loadingID = banner._id;
      try {
        await this.updateBanner(banner);
        this.setSnackbar({ text: "Banner updated" });
      } catch (error) {
        //   xx
      }
      this.loadingID = "";
    },
  },
  async created() {
    this.loading = true;
    try {
      await this.fetchBanners();
      await this.fetchAdvertisers();
    } catch (error) {
      // xx
    }
    this.loading = false;
  },
};
</script>

<style></style>
